import {
   Component,
   ChangeDetectionStrategy,
   EventEmitter,
   Input,
   Output
} from '@angular/core';
import { NgIf, NgForOf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';

@Component({
   selector: 'app-active-features-access',
   standalone: true,
   imports: [NgIf, NgForOf, ButtonModule, RouterModule],
   templateUrl: './active-features-access.component.html',
   styleUrls: ['./active-features-access.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActiveFeaturesAccessComponent {
   @Input() isListsLoading = false;
   @Input() isAiActivatedTasksLoading = false;

   @Input() activeGroups: string[] = [];
   @Input() activeUsers: string[] = [];

   @Input() noActiveGroups = 0;
   @Input() noActiveUsers = 0;

   @Input() aiTasksActivated: string[] = [];
   @Input() aiTasksActivatedCount = 0;

   @Input() addOns: string[] = ['Nil'];

   @Output() download = new EventEmitter<void>();

   trackByIndex = (_: number, x: unknown) => x;
}
